import { Flex } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";
import { useErrorModal, useSpaNavigate } from "shared-ui";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import type { SelectFundingFormFields } from "../../components";
import { SelectFundingEntryForm } from "../../components";
import { NAVIGATION_PATHS } from "../../components/constants";
import { useSubmitSubsequentFundingApplication } from "../../queries/funding-application/queries";
import { useFundingConfiguration } from "../../queries/funding-configuration/queries";

const FORM_ID = "additional-funding-form";

export const AdditionalFundingForm = () => {
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { navigate } = useSpaNavigate("FundingApp");
  const { data: fundingConfiguration } = useFundingConfiguration(customerDomain);
  const { openErrorModal } = useErrorModal();
  const { mutateAsync: submitSubsequentFundingApplication } = useSubmitSubsequentFundingApplication(customerDomain);

  const onSubmit = async (formData: SelectFundingFormFields) => {
    try {
      await submitSubsequentFundingApplication({
        ...formData,
        intendedUse: formData.intendedUse.join(","),
        preferredFundsDeploymentDate: formData.preferredFundsDeploymentDate || undefined,
        requestedAmountCurrency: formData.requestedAmountCurrency as FundingApplicationSchemas.Currency,
      });
      navigate(NAVIGATION_PATHS.IN_REVIEW);
    } catch (error: any) {
      openErrorModal({ variant: "submit-error", error });
    }
  };

  return (
    <Flex direction="column" gap="8">
      <SelectFundingEntryForm
        onSubmit={onSubmit}
        initialValues={{
          requestedAmount: 0,
          requestedAmountCurrency: fundingConfiguration?.lastDealCurrency || "USD",
          intendedUse: [],
          preferredFundsDeploymentChoice: "asap",
          preferredFundsDeploymentDate: null,
        }}
        formId={FORM_ID}
      />
    </Flex>
  );
};
